import type { GridSpecificProps } from './Grid.props'

const Grid = ({ children, ...gridStyles }: GridSpecificProps) => {
  return <div style={{ display: 'grid', ...gridStyles }}>{children}</div>
}

export { Grid }
